import { render, staticRenderFns } from "./ScaniaMainMenu.vue?vue&type=template&id=7b1a618c&"
import script from "./ScaniaMainMenu.vue?vue&type=script&lang=js&"
export * from "./ScaniaMainMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports